import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#85D1DB', dark: '#6BB8C3', light: '#B3EBF2' },
    secondary: { main: '#B6F2D1', dark: '#A4E0BF', light: '#C9FDF2' },
    error: { main: '#dc2626' },
    warning: { main: '#d97706' },
    success: { main: '#16a34a' },
    background: { default: '#F0FBFC', paper: '#ffffff' },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif",
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 700 },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontFamily: "'Roboto', sans-serif", fontWeight: 600, borderRadius: 12, transition: 'all 0.2s ease', '&:hover': { transform: 'translateY(-1px)' } },
        containedPrimary: { color: '#0f172a', background: 'linear-gradient(135deg,#85D1DB,#B6F2D1)', boxShadow: '0 4px 14px rgba(133,209,219,0.4)', '&:hover': { background: 'linear-gradient(135deg,#6BB8C3,#A4E0BF)', boxShadow: '0 6px 24px rgba(133,209,219,0.5)' } },
      },
    },
    MuiCard: {
      styleOverrides: { root: { borderRadius: 16, border: '1px solid rgba(226,232,240,0.8)', boxShadow: '0 4px 24px rgba(0,0,0,0.03)' } },
    },
    MuiPaper: {
      styleOverrides: { root: { fontFamily: "'Roboto', sans-serif" } },
    },
    MuiTextField: {
      styleOverrides: { root: { '& .MuiInputBase-root': { fontFamily: "'Roboto', sans-serif", fontSize: 13 } } },
    },
    MuiTableHead: {
      styleOverrides: { root: { '& .MuiTableCell-root': { backgroundColor: '#f8fafc', fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#64748b', whiteSpace: 'nowrap', padding: '12px 16px', borderBottom: '1px solid #e2e8f0' } } },
    },
    MuiTableCell: {
      styleOverrides: { root: { fontFamily: "'Roboto', sans-serif", fontSize: 13, borderColor: '#f1f5f9', padding: '14px 16px' } },
    },
    MuiChip: {
      styleOverrides: { root: { fontFamily: "'Roboto', sans-serif", fontSize: 11, fontWeight: 600, borderRadius: 99 } },
    },
    MuiTab: {
      styleOverrides: { root: { fontFamily: "'Roboto', sans-serif", textTransform: 'none', fontWeight: 500 } },
    },
    MuiSnackbar: {
      defaultProps: { anchorOrigin: { vertical: 'bottom', horizontal: 'right' } },
    },
  },
});
